import { render, staticRenderFns } from "./connected-user-info.html?vue&type=template&id=2d418765&scoped=true&external"
import script from "./connected-user-info.js?vue&type=script&lang=js&external"
export * from "./connected-user-info.js?vue&type=script&lang=js&external"
import style0 from "./connected-user-info.scss?vue&type=style&index=0&id=2d418765&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d418765",
  null
  
)

export default component.exports